import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Popconfirm, Button, Input, message,Select } from 'antd';
import { RegisterPositive, RegisterPromotion } from './PromotionModal';
import ChangeLog from '../../teachingManagement/Component/ChangeLog';
import RegisterTeaching from '../../teachingManagement/management/components/RegisterTeaching';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import { saveParams } from '../../../actions/noticeActions';

const { Option } = Select;

class Filter extends Component {
    constructor(props) {
        super(props);
        const { params } = this.props;
        this.state = {
            searchParams: {
                ...params,
                workStatus: 'WORKING',
            },
        }
    }

    componentDidMount() {
        this.search();
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search({ ...searchParams });
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    handleInputChange = (e, field) => {
        const { searchParams } = this.state;
        searchParams[field] = e.target.value;
        this.setState({ searchParams });
    }

    handleSelectChange = (value, field) => {
        const { searchParams } = this.state;
        searchParams[field] = value;
        this.setState({ searchParams });
    }

    render() {
        const {
            searchParams: {
                employeeCode,
                userCompellation,
                workStatus,
            }
        } = this.state;
        return (
            <div className="filter-bar">
                <div className="form-item">
                    <label htmlFor="" className="ui-label">工号</label>
                    <Input
                        placeholder="请输入"
                        value={employeeCode}
                        onChange={e => this.handleInputChange(e, 'employeeCode')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">姓名</label>
                    <Input
                        placeholder="请输入"
                        value={userCompellation}
                        onChange={e => this.handleInputChange(e, 'userCompellation')}
                        onKeyPress={this.enterSearch}
                    />
                </div>
                <div className="form-item">
                    <label htmlFor="" className="ui-label">状态</label>
                    <Select
                        onChange={value => this.handleSelectChange(value, 'workStatus')}
                        placeholder="请选择"
                        value={workStatus}
                        style={{width:90}}
                        allowClear={true}
                    >
                        <Option value="WORKING">在职</Option>
                        <Option value="LEFT">离职</Option>
                    </Select>
                </div>
                <div className="form-item">
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        );
    }
}

class Promotion extends Component {
    state = {
        data: [],
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 3,
            current: 1,
        },
        loading: false,
        expandedRowKeys: [],
        subList: {},
        role: {},
    }

    componentDidMount() {
        const { curRole } = sessionStorage;
        const role = {
            isVP: curRole == 'VP',
            isFIN: curRole == 'FIN',
            isHRRC: curRole == 'HRRC',
        };
        this.setState({ role });
    }

    componentWillUnmount() {
        this.props.saveParams({ employeeCode: undefined, activeKey: undefined });
    }

    search = (params = {}) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams: params,
        }, () => {
            this.loadData();
        });
    }

    loadData = () => {
        const { sortParams, searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryTeacherListByParams,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount = 0 } = res;
                pagination.total = totalCount;

                const expandedRowKeys = [];
                const values = Object.values(searchParams);
                if (values.some(i => !!i)) {
                    datas.forEach(i => expandedRowKeys.push(i.userId));
                }

                this.setState({
                    pagination,
                    data: datas,
                    loading: false,
                    expandedRowKeys,
                }, () => {
                    expandedRowKeys.forEach(i => this.loadSubData(i));
                });
            }
        };
        $.sendRequest(options);
    }

    loadSubData = (userId) => {
        const { searchParams } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.queryUserPromotionByUserId,
            data: {
                ...searchParams,
                userId,
            },
            dataType: 'json',
            doneResult: res => {
                const { subList } = this.state;
                subList[userId] = res.list;
                this.setState({
                    subList,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    subDelete = (row) => {
        const { userId, userPromotionId } = row;

        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.user.delUserPromotion,
            data: { userPromotionId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadSubData(userId);
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.sort = sorter.field ;
        sortParams.direction = sorter.order ? sorter.order == 'descend' ? 'DESC' : 'ASC' : '';
        this.setState({
            subList: {},
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    getDateRender = text => text ? text.slice(0, 10) : ''

    getColumns = () => {
        const { role: { isVP, isFIN, isHRRC } } = this.state;
        const columns = [{
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 80,
            sorter: true,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 80,
        }, {
            title: '职位/级别',
            dataIndex: 'positionName',
            key: 'positionName',
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
        }, {
            title: '带教老师工号',
            dataIndex: 'teacherCode',
            key: 'teacherCode',
            width: 120,
        }, {
            title: '带教老师姓名',
            dataIndex: 'teacherName',
            key: 'teacherName',
            width: 120,
        }, {
            title: '入职时间',
            dataIndex: 'joinTime',
            key: 'joinTime',
            render: this.getDateRender,
        }, {
            title: '转正时间',
            dataIndex: 'positiveTime',
            key: 'positiveTime',
            render: this.getDateRender,
        }];
        if (!(isVP || isFIN || isHRRC)) {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                key: 'operate',
                width: 260,
                render: (text, record) => {
                    return (
                        <span>
                            <a onClick={() => this.registerTeaching(record)}>登记带教老师</a>
                            <span className="ant-divider" />
                            <a onClick={() => this.registerPromotion(record)}>登记晋升信息</a>
                            <span className="ant-divider" />
                            <a onClick={() => this.showChangeLog(record)}>带教老师变更日志</a>
                        </span>
                    )
                }
            })
        }
        return columns;
    }

    getDataSource = () => {
        const { data, pagination: { current, pageSize } } = this.state;
        const dataSource = data.map((item, index) => {
            const { workStatus, noNeedTeacher, teacherCode, teacherName } = item;
            return {
                index: (current - 1) * pageSize + index + 1,
                ...item,
                teacherCode: noNeedTeacher == 1 ? 'NA' : teacherCode,
                teacherName: noNeedTeacher == 1 ? 'NA' : teacherName,
                workStatus: workStatus ? (workStatus === 'WORKING' ? '在职' : "离职") : '',
            };
        });
        return dataSource;
    }

    onExpand = (expanded, record) => {
        const { expandedRowKeys } = this.state;
        if (expandedRowKeys.length == 0) {
            expandedRowKeys.push(record.userId);
        } else {
            if (expanded) {
                expandedRowKeys.push(record.userId);
            } else {
                expandedRowKeys.map((item, index) => {
                    if (item == record.userId) {
                        expandedRowKeys.splice(index, 1);
                    };
                });
            }
        }
        this.setState({ expandedRowKeys });
        if (expanded) {
            this.loadSubData(record.userId);
        }
    }

    expandedRowRender = (record) => {
        const { userId } = record;
        const { role: { isVP, isFIN, isHRRC }, subList } = this.state;
        const subData = subList[userId] || [];

        const getDateRender = text => text ? text.slice(0, 10) : '';
        const getColumns = () => {
            const columns = [{
                title: '序号',
                dataIndex: 'index',
                key: 'index',
                width: 60,
            }, {
                title: '晋升时间',
                dataIndex: 'promotionTime',
                key: 'promotionTime',
                width: 170,
                render: getDateRender,
            }, {
                title: '晋升方式',
                dataIndex: 'promotionTypeShow',
                key: 'promotionTypeShow',
                width: 175,
            }, {
                title: '晋升前职位',
                dataIndex: 'beforePositionName',
                key: 'beforePositionName',
                width: 175,
                render: (text, row) => {
                    const { beforeDepartmentName } = row;
                    return beforeDepartmentName ? `${beforeDepartmentName}-${text}` : null;
                }
            }, {
                title: '晋升后职位',
                dataIndex: 'afterPositionName',
                key: 'afterPositionName',
                width: 175,
                render: (text, row) => {
                    const { afterDepartmentName } = row;
                    return afterDepartmentName ? `${afterDepartmentName}-${text}` : null;
                }
            }];
            if (!(isVP || isFIN || isHRRC)) {
                columns.push({
                    title: '操作',
                    dataIndex: 'operate',
                    key: 'operate',
                    width: 120,
                    render: (text, row) => {
                        return (
                            <span>
                                <a onClick={() => this.registerPromotion(record, row)}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title="确定要删除吗?" onConfirm={() => this.subDelete(row)}>
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )
                    }
                });
            }
            return columns;
        }
    
        const getDataSource = () => {
            const dataSource = [];
    
            if (subData && subData.length > 0) {
                subData.map((item, index) => {
                    dataSource.push({
                        index: index + 1,
                        ...item,
                    });
                });
            }
            return dataSource;
        };

        return (
            <Table
                rowKey={record => record.index}
                columns={getColumns()}
                dataSource={getDataSource()}
                pagination={false}
                scroll={{ x: 875, y: 300 }}
            />
        );
    }

    registerTeaching = (params) => {
        this.registerTeachingRef.show({...params});
    }

    registerPositive = (params) => {
        this.registerPositiveRef.show({...params});
    }

    registerPromotion = (parentParams, params) => {
        this.registerPromotionRef.show(parentParams, params);
    }

    showChangeLog = (record) => {
        this.changeLogRef.show(record);
    }

    render() {
        const { params, employeeCode } = this.props;
        const { loading, pagination, expandedRowKeys } = this.state;
        return (
            <div>
                <Filter
                    params={{ employeeCode, ...params }}
                    search={this.search}
                    export={this.export}
                />
                <Table
                    loading={loading}
                    scroll={{ x: 1160 }}
                    pagination={pagination}
                    columns={this.getColumns()}
                    dataSource={this.getDataSource()}
                    rowKey={record => record.userId}
                    onChange={this.handleTableChange}
                    onExpand={this.onExpand}
                    expandedRowKeys={expandedRowKeys}
                    expandedRowRender={this.expandedRowRender}
                />
                <ChangeLog ref={el => this.changeLogRef = el} />
                <RegisterTeaching ref={el => this.registerTeachingRef = el} loadData={this.loadData} />
                <RegisterPositive ref={el => this.registerPositiveRef = el} loadData={this.loadData} />
                <RegisterPromotion ref={el => this.registerPromotionRef = el} loadData ={this.loadSubData} />
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    const { employeeCode } = state.noticeState.params || {};
    return {
        employeeCode,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveParams: params => dispatch(saveParams(params))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Promotion);


// WEBPACK FOOTER //
// ./src/components/user/userInfo/Promotion.js